import { render, staticRenderFns } from "./TariffsManagerLandingPage.vue?vue&type=template&id=68c2c96f&"
import script from "./TariffsManagerLandingPage.vue?vue&type=script&lang=js&"
export * from "./TariffsManagerLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports